<script>

	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	import './style.scss'

	import {
		URL_PREFIX
	} from '@/constants.js'

	export default {
		name: 'registerbox',
		components: {
			ClipLoader
		},
		data: () => ({
			loading: false,
			email: '',
			password: '',
			color: '#fff',
			URL_PREFIX
		}),
		methods: {
			registerAccount() {
				this.loading = true
				this.$store.dispatch('registerAccount', {
					email: this.email,
					password: this.password
				}).then((registerStatus) => {
					this.loading = false
					if (!!registerStatus) {
						this.$store.dispatch('notification', {
							show: true,
							type: 'success',
							message: 'You\'ve been registered! :)',
							duration: 5000,
						})
						this.$router.push('/')
					} else {
						this.$store.dispatch('notification', {
							show: true,
							type: 'error',
							message: 'There was an error with registration, please try again!',
							duration: 5000,
						})
					}
				});
			}
		},
	}

</script>

<template>
	<div class='registerbox'>
		<a href='/'>
			<img class='mobile' src='/static/logo-head-white.svg'>
		</a>
		<div class='registerbox-container'>
			<header>
				Sign Up
			</header>
			<form @submit.prevent='registerAccount({ email, password })' class='form-container'>
				<input
					v-model='email'
					type='email'
					name='email'
					placeholder='Email address'
					required
					:disabled='loading === true'
					autocomplete='new-password'
				/>
				<input
					v-model='password'
					type='password'
					name='password'
					placeholder='Password'
					required
					:disabled='loading === true'
					autocomplete='new-password'
				/>
				<button
					:disabled='loading === true'
					type='submit'
					:class='{ submit: true, loading, registerAccount }'
				>
					<span v-if='loading === false'>
						Register&nbsp;&nbsp;&nbsp;⟶
					</span>
					<span v-if='loading === true'>
						Signing In...&nbsp;&nbsp;&nbsp;
					</span>
				</button>

			</form>
		</div>
		<p class='account-tos'>
			Have an account?
			<a :href='`${URL_PREFIX}/login`'>Sign In</a>.
		</p>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/RegisterBox/RegisterBox.vue